export default {"src":"/_next/static/media/regularUpdates.5baf5bf4.svg","height":24,"width":24};